import { useOrganisationIntegration } from '../predict-management/hooks/useOrganisationIntegration';
import { useReconnectDatasourceByIds } from './use-reconnect-datasource-by-ids';

export const useReconnectDatasource = () => {
  const { workspaceId, organisationId, datasource, integration } = useOrganisationIntegration();

  return useReconnectDatasourceByIds(workspaceId, organisationId, datasource, integration);
};
